/**
 * @generated SignedSource<<af35aaf976d787b0e14e600e55dc3a25>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type ItemMenu_node$data = {
  readonly __typename: string;
  readonly id: string;
  readonly " $fragmentSpreads": FragmentRefs<"AccessOption_node" | "AnnounceOption_node" | "CreateShortcutOption_node" | "DeleteNodeOption_node" | "DownloadButton_node" | "DuplicateOption_node" | "EditOption_node" | "FavouriteButton_node" | "ManageVaultFieldsOption_node" | "MarkAsOption_node" | "MoveOption_node" | "PinOption_node" | "RenameOption_node" | "RequestSignaturesOption_node" | "ShareButton_node" | "Status_node" | "TagButton_node" | "TagsButton_node" | "ThumbnailOption_node">;
  readonly " $fragmentType": "ItemMenu_node";
};
export type ItemMenu_node$key = {
  readonly " $data"?: ItemMenu_node$data;
  readonly " $fragmentSpreads": FragmentRefs<"ItemMenu_node">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "ItemMenu_node",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "__typename",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "TagButton_node"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "TagsButton_node"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "Status_node"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "FavouriteButton_node"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "DownloadButton_node"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "ShareButton_node"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "EditOption_node"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "RenameOption_node"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "MoveOption_node"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "DeleteNodeOption_node"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "PinOption_node"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "DuplicateOption_node"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "AnnounceOption_node"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "CreateShortcutOption_node"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "AccessOption_node"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "ManageVaultFieldsOption_node"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "RequestSignaturesOption_node"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "ThumbnailOption_node"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "MarkAsOption_node"
    }
  ],
  "type": "Node",
  "abstractKey": "__isNode"
};

(node as any).hash = "abac953e14ab580c9a0b5e96e5f70fe6";

export default node;
